<table mat-table [style.width]="tabellenService.tableWidth" [dataSource]="dataSource"
       class="mat-elevation-z8" [trackBy]="trackByFn">

  <ng-container
      *ngFor="let column of tabellenService.displayedColumns; index as i"
      matColumnDef="{{column}}">
    <ng-container *ngIf="tabellenService.header.length > 0 && !!tabellenService.header[0].UIArtefakt[i]">
      <th [style.width]="tabellenService.columnWidths[i]" mat-header-cell *matHeaderCellDef
          [attr.colspan]="tabellenService.header[0].UIArtefakt[i]['Tabellenzellenspanne']"
          [ngStyle]="{'text-align': tabellenService.header[0].UIArtefakt[i]['Tabellenzellenspanne'] > 1 ? 'center' : 'unset',
        'display': tabellenService.header[0].UIArtefakt[i] ? 'table-cell' : 'none'}">
        <lv-uiartefakt-renderer
            [uiArtefakt]="tabellenService.header[0].UIArtefakt[i]"></lv-uiartefakt-renderer>
      </th>
    </ng-container>
    <ng-container>
    <td [style.width]="tabellenService.columnWidths[i]" mat-cell *matCellDef="let cellContent"
        [attr.colspan]="cellContent.UIArtefakt[i]?.Tabellenzellenspanne"
        [ngStyle]="{'text-align': cellContent.UIArtefakt[i]?.Tabellenzellenspanne > 1 ? 'center' : 'unset',
        'display': cellContent.UIArtefakt[i] ? 'table-cell' : 'none'}">
      <lv-uiartefakt-renderer *ngIf="cellContent.UIArtefakt[i]" [uiArtefakt]="cellContent.UIArtefakt[i]"></lv-uiartefakt-renderer>
    </td>
    </ng-container>
    <ng-container *ngIf="tabellenService.footer.length > 0 && !!tabellenService.footer[0].UIArtefakt[i]">
      <td [style.width]="tabellenService.columnWidths[i]" mat-footer-cell *matFooterCellDef
          [attr.colspan]="tabellenService.footer[0].UIArtefakt[i]['Tabellenzellenspanne']"
          [ngStyle]="{'text-align': tabellenService.footer[0].UIArtefakt[i]['Tabellenzellenspanne'] > 1 ? 'center' : 'unset',
        'display': tabellenService.footer[0].UIArtefakt[i] ? 'table-cell' : 'none'}">
        <lv-uiartefakt-renderer
            [uiArtefakt]="tabellenService.footer[0].UIArtefakt[i]"></lv-uiartefakt-renderer>
      </td>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="tabellenService.header.length > 0">
    <tr mat-header-row *matHeaderRowDef="tabellenService.displayedColumns"></tr>
  </ng-container>
  <tr mat-row *matRowDef="let row; columns: tabellenService.displayedColumns;"></tr>
  <ng-container *ngIf="tabellenService.footer.length > 0">
    <tr mat-footer-row *matFooterRowDef="tabellenService.displayedColumns"></tr>
  </ng-container>

</table>
<mat-paginator *ngIf="uiArtefakt.SichtbareZeilen" [pageSize]="uiArtefakt.SichtbareZeilen"
               showFirstLastButtons></mat-paginator>
